
export default class Placeholders {
	constructor() {
		const selectfields = document.querySelectorAll("select");
		
		if (selectfields.length) {
			selectfields.forEach((selectfield) => {
				// Initial
				selectfield.classList.add("placeholder-shown");

				// Check for placeholder text
				const placeholderText = selectfield.getAttribute("placeholder");
				if(placeholderText){
					const option = document.createElement("option");
					option.value = "";
					option.selected = true;
					option.textContent = placeholderText;
					selectfield.prepend(option);
				}

				// Change
				selectfield.addEventListener("change", (event) => {
					const target = event.currentTarget;
					if (target.value) {
						target.classList.remove("placeholder-shown");
						target.classList.add("placeholder-hidden");
					} else {
						target.classList.add("placeholder-shown");
						target.classList.remove("placeholder-hidden");
					}
				});
			});
		}

	}
}
